// FETCH ALL GARMENTS INWARD_DC
export const FETCH_GARMENTS_PO_INWARD_MASTER_REQUEST = 'FETCH_GARMENTS_PO_INWARD_MASTER_REQUEST';
export const FETCH_GARMENTS_PO_INWARD_MASTER_SUCCESS = 'FETCH_GARMENTS_PO_INWARD_MASTER_SUCCESS';
export const FETCH_GARMENTS_PO_INWARD_MASTER_FAILURE = 'FETCH_GARMENTS_PO_INWARD_MASTER_FAILURE';

// CREATE GARMENTS INWARD_DC
export const CREATE_GARMENTS_PO_INWARD_MASTER_REQUEST = 'CREATE_GARMENTS_PO_INWARD_MASTER_REQUEST';
export const CREATE_GARMENTS_PO_INWARD_MASTER_SUCCESS = 'CREATE_GARMENTS_PO_INWARD_MASTER_SUCCESS';
export const CREATE_GARMENTS_PO_INWARD_MASTER_FAILURE = 'CREATE_GARMENTS_PO_INWARD_MASTER_FAILURE';

// UPDATE GARMENTS INWARD_DC
export const UPDATE_GARMENTS_PO_INWARD_MASTER_REQUEST = 'UPDATE_GARMENTS_PO_INWARD_MASTER_REQUEST';
export const UPDATE_GARMENTS_PO_INWARD_MASTER_SUCCESS = 'UPDATE_GARMENTS_PO_INWARD_MASTER_SUCCESS';
export const UPDATE_GARMENTS_PO_INWARD_MASTER_FAILURE = 'UPDATE_GARMENTS_PO_INWARD_MASTER_FAILURE';

// FETCH SINGLE STATE OF GARMENTS INWARD_DC
export const FETCH_SINGLE_GARMENTS_PO_INWARD_MASTER_REQUEST = 'FETCH_SINGLE_GARMENTS_PO_INWARD_MASTER_REQUEST';
export const FETCH_SINGLE_GARMENTS_PO_INWARD_MASTER_SUCCESS = 'FETCH_SINGLE_GARMENTS_PO_INWARD_MASTER_SUCCESS';
export const FETCH_SINGLE_GARMENTS_PO_INWARD_MASTER_FAILURE = 'FETCH_SINGLE_GARMENTS_PO_INWARD_MASTER_FAILURE';

// DELETE GARMENTS INWARD_DC
export const DELETE_GARMENTS_PO_INWARD_MASTER_REQUEST = 'DELETE_GARMENTS_PO_INWARD_MASTER_REQUEST';
export const DELETE_GARMENTS_PO_INWARD_MASTER_SUCCESS = 'DELETE_GARMENTS_PO_INWARD_MASTER_SUCCESS';
export const DELETE_GARMENTS_PO_INWARD_MASTER_FAILURE = 'DELETE_GARMENTS_PO_INWARD_MASTER_FAILURE';

export const FETCH_PENDING_GARMENTS_PO_IN_INWARD_REQUEST = 'FETCH_PENDING_GARMENTS_PO_IN_INWARD_REQUEST';
export const FETCH_PENDING_GARMENTS_PO_IN_INWARD_SUCCESS = 'FETCH_PENDING_GARMENTS_PO_IN_INWARD_SUCCESS';
export const FETCH_PENDING_GARMENTS_PO_IN_INWARD_FAILURE = 'FETCH_PENDING_GARMENTS_PO_IN_INWARD_FAILURE';

export const RESET_GARMENTS_PO_INWARD_MASTER_INFO = 'RESET_GARMENTS_PO_INWARD_MASTER_INFO';

export const CREATE_GARMENTS_PO_INWARD_MASTER_FORM = 'CREATE_GARMENTS_PO_INWARD_MASTER_FORM';

export const UPDATE_GARMENTS_PO_INWARD_MASTER_FORM = 'UPDATE_GARMENTS_PO_INWARD_MASTER_FORM';

// NAVIGATE TO PARTY DETAILS COMPONENT
export const NAVIGATE_GARMENTS_PO_INWARD_DETAILS = 'NAVIGATE_GARMENTS_PO_INWARD_DETAILS';

// NAVIGATE TO GARMENTS INWARD_DC COMPONENT
export const NAVIGATE_GARMENTS_PO_INWARD_MASTER = 'NAVIGATE_GARMENTS_PO_INWARD_MASTER';

export const RESET_FORM_DATA_WITHOUT_GARMENTS_INWARD_ID = 'RESET_FORM_DATA_WITHOUT_GARMENTS_INWARD_ID';
export const SET_ACTIVE_KEY_GARMENTS_INWARD = 'SET_ACTIVE_KEY_GARMENTS_INWARD';

export const SET_UNIT_NAME_GARMENTS_PO_INWARD = 'SET_UNIT_NAME_GARMENTS_PO_INWARD';
export const SET_START_DATE_GARMENTS_PO_INWARD = 'SET_START_DATE_GARMENTS_PO_INWARD';
export const SET_END_DATE_GARMENTS_PO_INWARD = 'SET_END_DATE_GARMENTS_PO_INWARD';

